module.exports = __webpack_public_path__ + "img/shuffle.9e06c47d.svg";